module.exports = __webpack_public_path__ + "img/logo_msd_2.7c92e649.png";